import { Component, Input, Output, EventEmitter } from "@angular/core";
import { IIndicator } from "@gtmhub/error-handling";
import { ActionType, Entity, EntityType } from "@webapp/teams/models/status-actions.models";

@Component({
  selector: "gh-confirm-status-action",
  templateUrl: "./confirm-status-action.component.html",
  styleUrls: ["./confirm-status-action.component.less"],
})
export class ConfirmStatusActionComponent {
  @Input() public entity: Entity;
  @Input() public entityType: EntityType;
  @Input() public indicators: {
    loading?: IIndicator;
  } = {};
  @Input() public actionType: ActionType;

  @Output() public confirm: EventEmitter<void> = new EventEmitter();
  @Output() public close: EventEmitter<void> = new EventEmitter();

  get title(): { textKey: string } {
    return {
      textKey: {
        activate_user: "r_u_sure_activate_named_acc",
        deactivate_user: "r_u_sure_deactivate_named_acc",
        delete_user: "r_u_sure_remove_named_acc",
        activate_team: "activate_team_question",
        deactivate_team: "deactivate_team_question",
        delete_team: "delete_team_question",
      }[`${this.actionType}_${this.entityType}`],
    };
  }

  get legend(): { textKey: string } {
    return {
      textKey: {
        deactivate_user: "once_deactivate_cant_recover_user_data",
        delete_user: "once_removed_cant_recover_user_data",
        activate_team: "activate_team_warning",
        deactivate_team: "deactivate_team_warning",
        delete_team: "delete_team_warning",
      }[`${this.actionType}_${this.entityType}`],
    };
  }

  get actionButton(): { textKey: string; buttonDanger: boolean } {
    return {
      textKey: this.actionType,
      buttonDanger: this.actionType === "delete",
    };
  }

  public resetIndicator(indicator: keyof ConfirmStatusActionComponent["indicators"]): void {
    delete this.indicators[indicator];
  }
}
